export const DISPOSITION_EVENT = {
  LEAD_ASSIGNED: 'Lead Assigned',
  LEAD_FOLLOW_UP_ASSIGNED: 'Lead Follow Up Assigned',
  LEAD_REASSIGNED: 'Lead Reassigned',
  FOLLOW_UP_TASK_CREATED: 'Follow Up Task Created',
  FOLLOW_UP_TASK_COMPLETED: 'Follow Up Task Completed',
  FOLLOW_UP_TASK_UPDATED: 'Follow Up Task Updated',
  STATUS_UPDATE: 'Status Update',
  CLOSING_POOL_UPDATE: 'Closing Pool Update',
};
